const getItemsPerSlide = (isMobile: boolean, isTablet: boolean): number => {
	if (isMobile) return 1;
	if (isTablet) return 2;
	return 3;
};

export {getItemsPerSlide};
